module.exports = __webpack_public_path__ + "img/image41.9bb8b375.webp";